import { create } from 'zustand';

// Define the types for the state and the actions
interface SearchParamsState {
    placeId: string;
    city: string;
    lat: string | null;
    lng: string | null;
    passenger: string;
    std:  string | null;
    end:  string | null;

    setPlaceId: (placeId: string) => void;
    setCity: (city: string) => void;
    setLat: (lat: string | null) => void;
    setLng: (lng: string | null) => void;
    setPassenger: (passenger: string) => void;
    setStd: (std: string | null) => void;
    setEnd: (end: string | null) => void;
    setParams: (params: Partial<SearchParamsState>) => void;
}

export const useSearchStore = create<SearchParamsState>((set) => ({
    placeId: '',
    city: '',
    lat: null,
    lng: null,
    passenger: '',
    std: null,
    end: null,
    setPlaceId: (placeId: string) => set({ placeId }),
    setCity: (city: string) => set({ city }),
    setLat: (lat: string | null) => set({ lat }),
    setLng: (lng: string | null) => set({ lng }),
    setPassenger: (passenger: string) => set({ passenger }),
    setStd: (std:  string | null) => set({ std }),
    setEnd: (end:  string | null) => set({ end }),
    setParams: (params: Partial<SearchParamsState>) => set((state) => ({
        ...state,
        ...params,
    })),
}));
